<template>
  <div class="lb">
    <div
      ref="barMian"
      class="barMian"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope93",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope93-【组件】双柱图-带增长动画",
      timer: null,
      defaultdata: [
        {
          value2: "数值一",
          value3: "系列一",
          value4: "57",
          value5: "系列二",
          value6: "32",
        },
        {
          value2: "数值二",
          value3: "系列一",
          value4: "5",
          value5: "系列二",
          value6: "36",
        },
        {
          value2: "数值三",
          value3: "系列一",
          value4: "46",
          value5: "系列二",
          value6: "55",
        },
        {
          value2: "数值四",
          value3: "系列一",
          value4: "42",
          value5: "系列二",
          value6: "30",
        },
        {
          value2: "数值五",
          value3: "系列一",
          value4: "55",
          value5: "系列二",
          value6: "35",
        },
      ],
      valueMap: [
        { name: "名称", key: "value2" },
        { name: "柱状图一图例", key: "value3" },
        { name: "柱状图一数据", key: "value4" },
        { name: "柱状图二图例", key: "value5" },
        { name: "柱状图二数据", key: "value6" },
        { name: "单位", key: "value7" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.DrawEcharts();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      let data1 = [];
      let data2 = [];
      let legend = [];
      let vdata = JSON.parse(JSON.stringify(this.defaultdata));
      let yData = [...new Set(vdata.map((item) => item.value2))];
      let xData2 = [...new Set(vdata.map((item) => item.value1))];
      let chartlist = xData2.map((item) => {
        let list = vdata.filter((del) => del.value1 == item);
        return { name: item, data: list };
      });
      console.log('__chartlist', chartlist)
      chartlist[0].data.forEach((item, i) => {
        if (item.value3 && item.value4) {
          const vdata1 = { name: item.value2, value: item.value4 };
          data1.push(vdata1);
        }
        if (item.value5 && item.value6) {
          const vdata2 = { name: item.value5, value: item.value6 };
          data2.push(vdata2);
        }
        if (i == 0) {
          if (item.value3) {
            legend.push({
              show: true,
              top: "1%",
              right: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              icon: "rect",
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [item.value3 || ""],
            });
          }
          if (item.value5) {
            legend.push({
              show: true,
              top: "1%",
              left: "50%",
              itemHeight: 12, //图例的高度  文字左边那个
              itemWidth: 10,
              icon: "rect",
              textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
              data: [item.value5 || ""],
            });
          }
        }
      });
      const percent = (5 / yData.length) * 100;
      const zoom = [
        {
          id: "scope93", // 唯一的id
          filterMode: "empty",
          yAxisIndex: [0], //滑动条为竖
          mayValueSpan: 5, // 显示数据的条数(默认显示10个)
          type: "slider",
          showDetail: false, //关闭：拖拽时候显示详细数值信息。
          dataBackground: {
            show: false,
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          selectedDataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          backgroundColor: "transparent",
          fillerColor: "transparent",
          borderColor: "transparent",
          start: 0,
          end: percent,
          right: 0,
        },
      ];
      var Toption = {
        // title: [
        //   {
        //     text: this.defaultdata[0].value7 || "",
        //     top: "0",
        //     left: "0",
        //     textStyle: {
        //       color: "#979AA0",
        //       fontSize: 12,
        //     },
        //   },
        // ],
        tooltip: {
          trigger: "axis",
        },
        legend: [...legend],
        grid: {
          left: "5px",
          right: "20px",
          bottom: "10px",
          top: "30px",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
        },
        yAxis: {
          type: "category",
          z: 10,
          data: yData,
          axisLabel: {
            interval: 0,
            width: 80,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            overflow: "truncate", //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            data: data1,
            type: "bar",
            name: vdata[0].value3 || "",
            barWidth: 12,
            barGap: "30%",
            smooth: true,
            label: {
              normal: {
                // position: [380, 2],
                position: "right",
                show: true, //关闭文字显示
                textStyle: {
                  color: "#0082fb",
                  fontSize: 12,
                },
              },
            },
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  1,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#033062", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0082fb", // 100% 处的颜色
                    },
                  ],
                  false
                ),
              },
            },
          },
          {
            data: data2,
            type: "bar",
            name: vdata[0].value5 || "",
            barWidth: 12,
            label: {
              // position: [10, 10], //在右显示
              normal: {
                // align: "right",
                position: "right",
                // position: [380, 2],
                show: true, //关闭文字显示
                textStyle: {
                  color: "#60ebd0",
                  fontSize: 12,
                },
              },
            },
            barGap: "30%",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                1,
                1,
                [
                  {
                    offset: 0,
                    color: "#1d4d51", // 0% 处的颜色
                  },

                  {
                    offset: 1,
                    color: "#60ebd0", // 100% 处的颜色
                  },
                ],
                false
              ),
            },
          },
        ],
        dataZoom: yData.length > 5 ? zoom : [],
        // animationDuration: 0,
        // animationDurationUpdate: 3000,
        // animationEasing: "linear",
        // animationEasingUpdate: "linear",
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.setData(); //需要刷新的数据
    this.DrawEcharts();
  },
};
</script>

<style scoped>
.lb {
  width: 435px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
